import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import loadable from '@common/react/loadable/loadableSettings';

import MastheadNaked from '@app/components/UI/MastHead/MastheadNaked';
import '@app/scss/components/middleText.scss';

const PrivacyPolicy = loadable(() => import(/* webpackChunkName: "Policies" */ '@app/components/Pages/Policies/PrivacyPolicy'));
const TermsAndConditions = loadable(() => import(/* webpackChunkName: "TermsAndConditions" */ '@app/components/Pages/Policies/TermsAndConditions'));
const SiteAccessibility = loadable(() => import(/* webpackChunkName: "SiteAccessibility" */ '@app/components/Pages/Policies/SiteAccessibility'));

const Policies: React.FC = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const item = location.pathname.split('/')[2];
	const title = item
		.split('-')
		.map((item) => item.charAt(0).toUpperCase() + item.slice(1, item.length))
		.join(' ');

	const [policyComponent, setPolicyComponent] = React.useState<React.ReactNode>(null);

	React.useEffect(() => {
		switch (item) {
			case 'privacy-policy':
				setPolicyComponent(<PrivacyPolicy />);
				break;
			case 'terms-and-conditions':
				setPolicyComponent(<TermsAndConditions />);
				break;
			case 'accessibility-policy':
				setPolicyComponent(<SiteAccessibility />);
				break;
			default:
				navigate('/not-found');
				break;
		}
	}, [location.pathname]);

	return (
		<>
			<MastheadNaked imageSrc={require('@app/images/blog-bg.jpg')} title={title} />
			{policyComponent}
		</>
	);
};

export default Policies;
